export const normalizeSize = (size?: string) => {
  switch (size) {
    case 'sm':
    case 'small':
      return 'small';
    case 'lg':
    case 'large':
      return 'large';
    default:
      return 'medium';
  }
};
